import { render, staticRenderFns } from "./DigitalSettings.vue?vue&type=template&id=31f58b36&"
import script from "./DigitalSettings.js?vue&type=script&lang=js&"
export * from "./DigitalSettings.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports